import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { DeskApiService } from './api/desk-api.service';

/** Desk is behind the `Features:Desk` flag: without it, the desk routes lead back to the dashboard. */
export const deskFeatureGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(DeskApiService).features().pipe(map(features => features.desk || router.createUrlTree(['/dashboard'])));
};
